import { NumeroALetras } from "./numatexto"

export const numatexto = NumeroALetras


